module.exports = " <div> <form :action=url class=dropzone :id=id> </form> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Droply.vue
// module id = 47
// module chunks = 0